// confirmationDialogReducer.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  openConfirmationDialog: false, // Default value
  titleToBeDeleted: '',
  noteBookmarkListItemToBeDeleted: null,
  callerConfirmationDialog: '',
  dialogTitle: '',
  buttonText: '',
};

const confirmationDialogSlice = createSlice({
  name: 'confirmationDialog',
  initialState,
  reducers: {
    setButtonText(state, action) {
      state.buttonText = action.payload;
    },
    setDialogTitle(state, action) {
      state.dialogTitle = action.payload;
    },
    setOpenConfirmationDialog(state, action) {
      state.openConfirmationDialog = action.payload;
    },
    setCallerConfirmationDialog(state, action) {
      state.callerConfirmationDialog = action.payload;
    },
    setTitleToBeDeleted(state, action) {
      state.titleToBeDeleted = action.payload;
    },
    setNoteBookmarkListItemToBeDeleted(state, action) {
      state.noteBookmarkListItemToBeDeleted = action.payload;
    },
    reset4ConfirmationDialog() {
      return initialState;
    },
  },
});

export const { setButtonText, setDialogTitle, setOpenConfirmationDialog, setCallerConfirmationDialog, setTitleToBeDeleted, setNoteBookmarkListItemToBeDeleted, reset4ConfirmationDialog } = confirmationDialogSlice.actions;

export default confirmationDialogSlice.reducer;
// const initialState = {
//   openConfirmationDialog: false, // Default value
//   // recordToBeDeleted: 0,
//   titleToBeDeleted: '',
//   noteBookmarkListItemToBeDeleted: null,
//   callerConfirmationDialog: '',
//   dialogTitle: '',
//   buttonText: '',
// };

// export default function confirmationDialogReducer(state = initialState, action) {
//   switch (action.type) {
//     case 'setButtonText':
//       return {
//         ...state,
//         buttonText: action.payload, // Update the selected book
//       };       
//     case 'setDialogTitle':
//       return {
//         ...state,
//         dialogTitle: action.payload, // Update the selected book
//       };    
//     case 'setOpenConfirmationDialog':
//       return {
//         ...state,
//         openConfirmationDialog: action.payload, // Update the selected book
//       };
//     case 'setCallerConfirmationDialog':
//       return {
//         ...state,
//         callerConfirmationDialog: action.payload, // Update the selected book
//       };     
//     case 'setTitleToBeDeleted':
//       return {
//         ...state,
//         titleToBeDeleted: action.payload, // Update the selected book
//       };     
//     case 'setNoteBookmarkListItemToBeDeleted':
//       return {
//         ...state,
//         noteBookmarkListItemToBeDeleted: action.payload, // Update the selected book
//       };          
//     case 'reset4ConfirmationDialog':
//       return initialState;     
//     default:
//       return state;
//   }
// }

// export const setButtonText = (e) => ({
//   type: 'setButtonText',
//   payload: e,
// });

// export const setDialogTitle = (e) => ({
//   type: 'setDialogTitle',
//   payload: e,
// });

// export const setOpenConfirmationDialog = (e) => ({
//   type: 'setOpenConfirmationDialog',
//   payload: e,
// });

// export const setCallerConfirmationDialog = (e) => ({
//   type: 'setCallerConfirmationDialog',
//   payload: e,
// });

// export const setTitleToBeDeleted = (e) => ({
//   type: 'setTitleToBeDeleted',
//   payload: e,
// });

// export const setNoteBookmarkListItemToBeDeleted = (e) => ({
//   type: 'setNoteBookmarkListItemToBeDeleted',
//   payload: e,
// });

// export const reset4ConfirmationDialog  = (e) => ({
//   type: 'reset4ConfirmationDialog',
//   payload: e,
// });